module.exports = __webpack_public_path__ + "static/media/NIHR.98642ba6.png";